import React from "react";
import Overlay from "ol/Overlay.js";
import { DomHelper } from "../../helpers/dom-helper";
import jQuery from "jquery";
import Fa from "../common/Fa";
global.jQuery = jQuery;
global.jquery = jQuery;
global.$ = jQuery;

/**
 * Visor con mapa y layers base.
 */
export default class OverlayPopup extends React.Component {
  /**
   * Estado de componente.
   */
  state = {
    content: ""
  };
  /**
   * Overlay
   */
  overlay = null;
  /**
   * Identificador del dom del overlay/
   * @field
   */
  _id = DomHelper.getId("popup");
  /**
   * Cuando el componete se monta se inicializar el overlay de openlayers.
   */
  componentDidMount() {
    this.props.onRef(this);
    this.overlay = new Overlay({
      element: document.getElementById(this._id),
      autoPan: true
    });
  }
  /**
   * @returns la referencia al overlay para añdir al mapa.
   */
  get() {
    return this.overlay;
  }

  /**
   * Se encarga de abrir el popup en la coordenada especificada
   */
  open(coordinate, content) {
    const $target = jQuery("#" + this._id).find(".ol-popup-closer");
    this.overlay.setPosition(coordinate);
    this.setState({ content: content });
    $target.off("click");
    $target.on("click", evt => {
      this.close();
      evt.target.blur();
    });
  }

  /**
   * Se encarga de cerrar el overly
   */
  close() {
    this.overlay.setPosition(undefined);
  }
  /**
   * Se encarga de renderizar el contendio del popup.
   */
  renderContent() {
    return this.state.content;
  }
  /**
   * Se encarga de renderizar el componente.
   */
  render() {
    return (
      <div id={this._id} className="ol-popup">
        <a className="ol-popup-closer">
          <Fa icon="times-circle" />
        </a>
        <div id="popup-content">{this.renderContent()}</div>
      </div>
    );
  }
}
